<template>
	<div id="index">
		<Singinheader :headertext="texted"></Singinheader>
		<div class="content">
			<div class="settledbaner" :style ="backgroundimg">
				<h4>申请成为商家</h4>
				<p>成为分销商后卖出商品，您可以获得佣金</p>
			</div>
			<div class="settledcon">
				<div class="settledconed">
					<div class="settlednav">
						<ul class="clearfloat">
							<li>
								<div class="settlednavtext">
									<span>1</span>
									<strong>填写信息</strong>
								</div>
							</li>
							<li>
								<div class="settlednavtext">
									<span>2</span>
									<strong>等待审核</strong>
								</div>
							</li>
							<li>
								<div class="settlednavtext">
									<span>3</span>
									<strong>审核成功</strong>
								</div>
							</li>
							<li class="active">
								<div class="settlednavtext">
									<span>4</span>
									<strong>缴纳保障金</strong>
								</div>
							</li>
						</ul>
					</div>
					<div class="inensure">
						<h4>缴纳保障金</h4>
						<div class="inensureup">
							<ul>
								<li class="clearfloat">
									<span>缴纳保障金金额：</span>
									<h6 v-text="money+'元'"></h6>
								</li>
								<li class="clearfloat">
									<span>用户须知：</span>
									<div class="inxuzhi">
										<div class="inxuzhicon">
											<!-- <p>为了打造一个诚信的交易平台，有效保证交易双方的利益，爱淘苗推出线上招投标保证金制度，保证金的金额为5000元。在没有交易，也没有违约的情况下，保证金可以随时申请退回，反之则处于冻结状态不能退回。如果交易过程中出现恶意违约，经投诉并有效举证后将罚没保证金。相关招投标保证金制度、协议内容，详见平台公告及《招投标保证金协议》。以下为缴纳保证金、申请退回保证金的具体操作方法。</p> -->
											<p v-if="user_notes">{{user_notes}}</p>
										</div>
										<div class="inxzbut">
											<el-checkbox v-model="checked">勾选即表示同意</el-checkbox>
											<strong>《用户须知》</strong>
										</div>
									</div>
								</li>
							</ul>
						</div>
						<div class="ttshop_rechargebut">
							<h5>支付方式</h5>
							<ul class="clearfloat">
								<li class="d-flex align-items-center justify-content-center" :class="{active: 0 == pay_index}" @click="payType(0)">
									<i><img class="img-default" src="../../assets/images/ttshop_wxzf.png" alt=""></i>
									<span>微信支付</span>
								</li>
								<li class="d-flex align-items-center justify-content-center" :class="{active: 1 == pay_index}" @click="payType(1)">
									<i><img class="img-default" src="../../assets/images/ttshop_zfbzf.png" alt=""></i>
									<span>支付宝支付</span>
								</li>
							</ul>
						</div>
						<div class="inensurelast clearfloat">
							<div class="inensuretext">
								<div class="clearfloat">
									<h5>应付金额：<span v-text="'￥'+money"></span></h5>
								</div>
								<div class="clearfloat">
									<p @click="submit()">提交订单</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
		<!-- 支付弹层 -->
		<div class="ttshop_pay">
			<el-dialog title="" :visible.sync="pay_cont_type" :before-close="payContTypeChange">
				<div class="pay-title d-flex align-items-center justify-content-center">微信支付￥{{money}}</div>
				<div class="pay-qrcode d-flex align-items-center justify-content-center">
					<div id="qrcode" ref="qrcode"></div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import Singinheader from "../signup/components/singinheader.vue";
	import Foot from "@/components/foot/foot";
	import QRCode from "qrcodejs2";
	let Base64 = require("js-base64").Base64;
	export default {
		components: {
			Singinheader,
			Foot,
		},
		data() {
			return {
				texted: "商家入驻",
				backgroundimg: {
				  backgroundImage: "url(" + require("../../assets/images/settled.png") + ")",
				},
				checked: false,
				pay_index:0, //支付方式0 微信，1 支付宝
				mch_type: this.$route.query.mch_type,
				money: 0, //缴纳保证金
				pay_cont_type: false, //微信支付弹层
				shop_status_query: '', //商户入驻状态
				user_notes:'',//用户须知 
			};
		},
		created() {
			this.mchMoney();
			this.getMyShop();
			this.agreement();
		},
		methods:{
			//用户须知
			agreement(){
				var that=this;
				this.$api.user_notice({}).then(res=>{
					that.user_notes=res.data;
				}).catch(err=>{
					console.log(err)
				})
			},
			// 保证金金额
			mchMoney(){
				this.$loading();
				let params = {
					mch_type: this.mch_type,
				}
				this.$api.mchMoney(params).then(res => {
					this.$loading().close();
					this.money = res.data;
				}).catch(err => {
					this.common.message(this,err)
				});
			},
			// 支付方式
			payType(index){
				this.pay_index = index;
			},
			// 获取商户入驻状态
			getMyShop() {
				let params = {
					mch_type: this.mch_type
				}
				this.$api.myShop(params).then(res => {
					if(res.code == 0){
						clearInterval(this.shop_status_query);
						this.$message.success("入驻成功");
						setTimeout(()=>{
							this.$router.replace("/");
						},1000)
					}
				}).catch(err => {
					
				});
			},
			// 提交
			submit() {
				if(!this.checked){
					this.$message.warning("请阅读并同意用户须知");
					return false;
				}
				let params = {
					mch_type: this.mch_type,
				}
				if(this.pay_index == 0){
					params.pay_type = "WECHAT_PAY"
				}else if(this.pay_index == 1){
					params.pay_type = "ALIPAY"
				}
				this.shop_status_query = setInterval(() => {
					this.getMyShop();
				}, 5000);
				this.$api.payMoney(params).then(res => {
					if(this.pay_index == 0){ //微信支付
						this.pay_cont_type = true;
						let url = Base64.decode(res.res.code_url);
						setTimeout(()=>{
							this.qrcodeScan(url);
						},100)
					} else if(this.pay_index == 1){ //支付宝支付
						const div = document.createElement('div');
						div.innerHTML = res.data;
						document.body.appendChild(div);
						document.forms[0].submit();
					}
				}).catch(err => {
					this.common.message(this,err)
				});
			},
			//生成二维码
			qrcodeScan(url) {
				this.$refs.qrcode.innerHTML = "";
				console.log(url)
				let qrcode = new QRCode("qrcode", {
					width: 150,
					height: 150,
					text: url,
				});
			},
			// 支付二维码关闭
			payContTypeChange() {
				this.$confirm('是否取消支付', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.pay_cont_type = false;
					clearInterval(this.shop_status_query);
				}).catch(() => {
					
				});
			},
		}
	};
</script>

<style lang="scss">
	.content{
		width: 100%;
		padding-bottom: 60px;
		box-sizing: border-box;
		background: #F2F2F2;
		.settledbaner{
			width: 100%;
			height: 369px;
			padding-top: 62px;
			box-sizing: border-box;
			background-position: center;
			background-repeat: no-repeat;
			h4{
				font-size: 67px;
				color: #fff;
				text-align: center;
				line-height: 94px;
				text-shadow: 0px 2px 10px rgba(174, 10, 10, 0.44);
				margin-bottom: 4px;
			}
			p{
				font-size: 24px;
				color: #fff;
				text-align: center;
				line-height: 24px;
				font-weight: 400;
				
			}
		}
		.settledcon{
			width: 100%;
			.settledconed{
				width: 990px;
				background: #fff;
				padding: 0 56px;
				box-sizing: border-box;
				margin: -80px auto 0;
				.settlednav{
					width: 100%;
					height: 80px;
					border-bottom: 1px solid #EBEBEB;
					ul{
						display: table;
						margin: 0 auto;
						li{
							float: left;
							position: relative;
							line-height: 80px;
							margin-right: 60px;
							&:last-child{margin-right: 0;}
							&.active .settlednavtext::before{width: 100%;}
							&.active .settlednavtext span{background: #FF9010;color: #fff;}
							&.active .settlednavtext strong{color: #FF9010;}
							.settlednavtext{
								position: relative;
								&::before{
									content: '';
									width: 0%;
									height: 1px;
									background: #FF9010;
									position: absolute;
									bottom: 0;
									left: 0;
								}
								span{
									display: inline-block;
									width: 24px;
									height: 24px;
									border-radius: 50%;
									text-align: center;
									line-height: 24px;
									font-size: 14px;
									color: #999;
									background: #EBEBEB;
									margin-right: 12px;
								}
								strong{
									display: inline-block;
									font-size: 12px;
									color: #999;
									font-weight: 400;
								}
							}
						}
					}
				}
				.inensure{
					width: 100%;
					padding: 36px 0 60px 0;
					box-sizing: border-box;
					background: #fff;
					h4{
						display: block;
						width: 100%;
						height: 40px;
						background: #F3F3F3;
						padding: 0 13px;
						box-sizing: border-box;
						font-size: 14px;
						color: #333;
						font-weight: 400;
						line-height: 40px;
						margin-bottom: 28px;
					}
					.inensureup{
						width: 100%;
						padding-bottom: 32px;
						border-bottom: 1px dashed #E6E6E6;
						margin-bottom: 30px;
						box-sizing: border-box;
						ul{
							li{
								width: 100%;
								padding-left: 30px;
								margin-bottom: 28px;
								box-sizing: border-box;
								&:last-child{margin-bottom: 0;}
								>span{
									float: left;
									width: 115px;
									font-size: 14px;
									color: #333;
									font-weight: 400;
									line-height: 14px;
									text-align: right;
									margin-right: 10px;
								}
								h6{
									float: left;
									font-size: 14px;
									color: #FF4300;
									font-weight: 400;
									line-height: 15px;
								}
								.inxuzhi{
									float: left;
									width: 85%;
									.inxuzhicon{
										width: 100%;
										padding: 15px;
										border: 1px solid #C7D3D5;
										background: #F0F8FF;
										box-sizing: border-box;
										margin-bottom: 20px;
										p{
											font-size: 12px;
											color: #999;
											font-weight: 400;
											line-height: 20px;
										}
									}
									.inxzbut{
										width: 100%;
										strong{
											font-size: 12px;
											color: #347FF6;
											font-weight: 400;
											line-height: 12px;
											cursor: pointer;
										}
									}
								}
							}
						}
					}
					.ttshop_rechargebut{
						width: 100%;
						padding-bottom: 40px;
						border-bottom: 1px dashed #E6E6E6;
						box-sizing: border-box;
						margin-bottom: 30px;
						h5{
							font-size: 16px;
							color: #333;
							font-weight: 400;
							line-height: 16px;
							margin-bottom: 24px;
						}
						ul{
							li{
								float: left;
								margin-right: 20px;
								border: 1px solid #EBEBEB;
								width: 158px;
								height: 40px;
								border-radius: 4px;
								cursor: pointer;
								position: relative;
								padding: 5px;
								box-sizing: border-box;
								&::before{
									content: "";
									width: 12px;
									height: 12px;
									background: url(../../assets/images/ttshop_actives.png) center no-repeat;
									position: absolute;
									bottom: -1px;
									right: 0px;
									display: none;
								}
								&:last-child{
									margin-right: 0;
								}
								&.active{
									border-color: #FF3346;
								}
								&.active::before{
									display: block;
								}
								i{
									display: block;
									width: 27px;
									height: 24px;
									margin-right: 8px;
									img{
										display: block;
										width: 100%;
									}
								}
								span{
									font-size: 16px;
									color: #666;
									font-weight: 400;
									line-height: 16px;
								}
							}
						}
					}
					.inensurelast{
						width: 100%;
						.inensuretext{
							float: right;
							h5{
								font-size: 12px;
								color: #666;
								font-weight: 400;
								margin-bottom: 20px;
								float: right;
								span{
									font-size: 22px;
									color: #FF4300;
									font-weight: 500;
								}
							}
							p{
								float: right;
								width: 104px;
								height: 40px;
								border-radius: 2px;
								background: #FF0E25;
								font-size: 16px;
								color: #fff;
								text-align: center;
								line-height: 40px;
								cursor: pointer;
								transition: .5s;
								-moz-transition: .5s;
								-webkit-transition: .5s;
								-o-transition: .5s;
								&:hover{box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);}
							}
						}
					}
				}
			}
		}
	}
	.ttshop_pay {
		.pay-title {
			width: 100%;
			font-size: 14px;
			font-weight: bold;
			margin-bottom: 10px;
		}
	
		.pay-qrcode {
			width: 200px;
			height: 200px;
		}
	}
	/* 支付二维码 */
	.ttshop_pay .el-dialog {
	  width: 350px !important;
	  border-radius: 10px;
	}
	
	.ttshop_pay .el-dialog__header {
	 display: none;
	}
	.ttshop_pay .el-dialog__body {
	  padding: 60px 75px !important;
	}
	
	.ttshop_pay .el-dialog__title {
	  font-size: 14px !important;
	  color: #333333 !important;
	  font-weight: 500 !important;
	}
	
	.ttshop_pay .el-dialog__headerbtn {
	  top: 13px !important;
	}
	
	.ttshop_pay .el-input__inner {
	  padding-left: 14px !important;
	  padding-right: 14px !important;
	  border-radius: 2px !important;
	  height: 28px !important;
	}
	
	.ttshop_pay .el-input {
	  width: 280px !important;
	}
	
	.ttshop_pay input:focus {
	  border: 1px solid #EBEBEB !important;
	}
</style>
